import { useQuery } from '@tanstack/react-query'
import api from '@/lib/api'
import { useAccessToken } from '@/features/auth/state/auth'

export function useFetchPreviewAgreementById(editId: string, highlight = true) {
  const token = useAccessToken()
  return useQuery({
    queryKey: ['agreement-edit-preview', editId, highlight],
    queryFn: async () => {
      const { data } = await api.get(`/agreement-edit/preview/${editId}?highlight=${highlight ? 1 : 0}`, {
        headers: { Authorization: `Bearer ${token}` }
      })
      return data // { preview, edit, agreement }
    },
    enabled: !!editId && !!token
  })
}
